<kl-ol-map-base-layer @change="changeLayer" :mod-toggle="layers.length === 2" v-if="layers.length > 1">
	<kl-ol-map-base-layer-toggle v-for="layer in layers" :title="layer.name" :image="layer.thumbnail" :value="layer.id" :active="layer.active" />
</kl-ol-map-base-layer>
